export default "__VITE_ASSET__BeffCU2C__"